import { ToolType, ToolTypeToMockToolResponse } from './types'

export const DEFAULT_TOOL_INPUT_NAME = 'toolInput'
export const minimumLoadingTime = 3000
export const copyTooltipDismissTime = 5000

// Make sure to update this in the tool.module.scss file as well.
export const smallFoldHeight = 699

export const detectedAIColor = '#5E47E5'
export const noDetectedAIcolor = '#16AC9A'

export const defaultMinimumWordLimit = 0
export const defaultMaximumWordLimit = 1000

const defaultMaximumCharacterLimit = 20000 // 2000 words (10 characters per word)

const maximumCharacterLimitByToolType: Partial<Record<ToolType, number>> = {
  aiDetector: 10000,
}
export const maximumCharacterLimit = (toolType: ToolType) => {
  return maximumCharacterLimitByToolType[toolType] ?? defaultMaximumCharacterLimit
}

// Copy
// @todo move this to a dictionary or internationalization file - https://grammarly.atlassian.net/browse/G2A-1966
export const DEFAULT_SUBMIT_BUTTON_TEXT = 'Check text'
export const DEFAULT_PLACEHOLDER_TEXT = 'Type, paste, or upload your text.'
export const DEFAULT_FOOTER_BANNER_COPY = 'Join millions who write better, faster with Grammarly.'
export const DEFAULT_NEXT_BEST_ACTION_COPY = 'Go beyond with Grammarly.'
export const DEFAULT_TOOL_API_ERROR_MESSAGE = 'Something went wrong. Please try again in a few seconds.'

// Errors
export enum ToolErrors {
  MIN_WORD_LIMIT_ERROR = 'Please enter at least {minWordLimit} words',
  EMPTY_TEXT_ERROR = 'Please enter text',
}

// Using for local testing - hopefully temporary until we get CAPI connected.
export const mockResponseByToolType: ToolTypeToMockToolResponse = {
  aiDetector: {
    group: 'not used',
    category: 'not used',
    categoryHuman: 'not used',
    score: 50,
    alertRanges: [
      { begin: 10, end: 20 },
      { begin: 20, end: 30 },
      { begin: 30, end: 40 },
    ],
  },
  plagiarismChecker: [
    {
      category: 'BasicPunct',
      group: 'Punctuation',
      categoryHuman: 'Comma misuse within clauses',
      count: 3,
    },
    {
      category: 'GeneralPunct',
      group: 'Punctuation',
      categoryHuman: 'Incorrect punctuation',
      count: 3,
    },
    {
      category: 'PassiveVoice',
      group: 'Style',
      categoryHuman: 'Passive voice misuse',
      count: 13,
    },
    {
      category: 'Wordiness',
      group: 'Style',
      categoryHuman: 'Wordy sentences',
      count: 13,
    },
    {
      category: 'Nouns',
      group: 'Grammar',
      categoryHuman: 'Incorrect noun number',
      count: 1,
    },
    {
      category: 'Plagiarism',
      group: 'Plagiarism',
      categoryHuman: 'Unoriginal content',
      count: 100,
    },
    {
      category: 'AccidentallyConfused',
      group: 'Spelling',
      categoryHuman: 'Confused words',
      count: 2,
    },
    {
      category: 'Formatting',
      group: 'Style',
      categoryHuman: 'Improper formatting',
      count: 1,
    },
    {
      category: 'WordChoice',
      group: 'Enhancement',
      categoryHuman: 'Word choice',
      count: 3,
    },
    {
      category: 'Pronouns',
      group: 'Grammar',
      categoryHuman: 'Pronoun use',
      count: 1,
    },
  ],
}
